<template>
    <v-dialog v-model="dialog" max-width="1500px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn
            color="primary"
            dark
            class="mx-2"
            v-bind="attrs"
            v-on="on"
            >เพิ่ม</v-btn>
        </template>

        <v-card outlined class="pa-3">
                <v-card-title ><strong>{{$t('customer_package_title')}}</strong></v-card-title>
                <v-divider class="ma-2"></v-divider>
                <div class="pl-5 pr-5">
                    <v-form ref="formData" lazy-validation>
                    <v-row>
                        <v-col>
                            <v-select
                                :disabled="isEdit"
                                v-model="editedItem.customer_id"
                                :items="customerList"
                                label="ลูกค้า"
                                item-value="customer_id"
                                item-text="customer_name"
                                :rules="[rules.required]"
                            >
                            </v-select>
                        </v-col>
                        <!--
                        <v-col style="text-align:left!important" v-if="!isEdit">
                             <DlgCustomer @onCloseDialog="onCloseDialog"></DlgCustomer>
                        </v-col>
                        -->
                        <v-col>
                            <v-select
                                v-model="editedItem.package_id"
                                :items="packageList"
                                label="แพ็คเกจ"
                                item-value="package_id"
                                item-text="package_name"
                            >
                            </v-select>
                        </v-col>
                    </v-row>
                    <PeriodComponent ref="period" @setPeriod="setPeriod" @setStartDate="setStartPackageDate" @setEndDate="setEndPackageDate"></PeriodComponent>
                    <v-row>
                        <v-col>
                            <v-card>
                                <v-toolbar flat color="#f0f8ff"
                                >
                                    <v-card-subtitle >ข้อมูลรายละเอียดแพ็คเกจหลัก</v-card-subtitle>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                                <v-divider></v-divider>
                                <v-card-text  class="text-left pr-5">
                                    <v-row>
                                        <v-col cols="1"></v-col>
                                        <v-col cols="6">รองรับสาขา</v-col>
                                        <v-col>{{getBooleanText(selectedPackage.branch)}}</v-col>
                                    </v-row>
                                     <v-row>
                                         <v-col cols="1"></v-col>
                                        <v-col cols="6">บริการจองคิว</v-col>
                                        <v-col>{{getBooleanText(selectedPackage.reservation)}}</v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="1"></v-col>
                                        <v-col cols="6">บริการนัดหมาย</v-col>
                                        <v-col>{{getBooleanText(selectedPackage.appointment)}}</v-col>
                                    
                                    </v-row>
                                    <v-row>
                                        <v-col cols="1"></v-col>
                                        <v-col cols="6">จำนวนข้อความต่อเดือน</v-col>
                                        <v-col >
                                            <v-text-field
                                              class="right-text"
                                              dense
                                              :rules="[rules.requiredNumber]"
                                              suffix=" / ข้อความ ต่อเดือน"
                                             v-model="selectedPackage.line_noti_per_month">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="1"></v-col>
                                        <v-col cols="6">Supervisor User</v-col>
                                        <v-col >
                                            <v-text-field
                                              class="right-text"
                                              :rules="[rules.requiredNumber]"
                                              dense
                                             v-model="selectedPackage.supervisor">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="1"></v-col>
                                        <v-col cols="6">Viewer User</v-col>
                                        <v-col >
                                            <v-text-field
                                              class="right-text"
                                              dense
                                              :rules="[rules.requiredNumber]"
                                             v-model="selectedPackage.viewer">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="1"></v-col>
                                        <v-col cols="6">ค่าธรรมเนียม สมาชิกที่รับการแจ้งเตือน</v-col>
                                        <v-col >
                                            <v-text-field
                                              class="right-text"
                                              dense
                                              suffix=" / บาท ต่อคน"
                                              :rules="[rules.requiredNumber]"
                                             v-model="selectedPackage.line_noti_member_fee">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="1"></v-col>
                                        <v-col cols="6">ค่าธรรมเนียม สมาชิกทุกคนในระบบ</v-col>
                                        <v-col >
                                            <v-text-field
                                              class="right-text"
                                              dense
                                              suffix=" / บาท ต่อคน"
                                              :rules="[rules.requiredNumber]"
                                             v-model="selectedPackage.member_fee">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <!--
                                    <v-row>
                                        <v-col cols="1"></v-col>
                                        <v-col cols="6">ค่าบริการระบบส่งข้อความรายเดือน</v-col>
                                        <v-col >
                                            <v-text-field
                                              class="right-text"
                                              dense
                                              suffix=" บาท"
                                              :rules="[rules.requiredNumber]"
                                             v-model="selectedPackage.line_message_service_charge">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    -->
                                    <v-row>
                                        <v-col cols="1"></v-col>
                                        <v-col cols="6">ค่าบริการแพลตฟอร์มรายเดือน</v-col>
                                        <v-col >
                                            <v-text-field
                                              class="right-text"
                                              dense
                                              suffix=" บาท"
                                              :rules="[rules.requiredNumber]"
                                             v-model="selectedPackage.platform_service_charge">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col>
                            <v-card>
                                <v-toolbar flat color="#f0f8ff"
                                >
                                    <v-card-subtitle >ข้อมูลบริการเสริม</v-card-subtitle>
                                    <v-spacer></v-spacer>
                                    <DlgExtPackage :items="extPackageList" @onCloseDialog="onCloseExtPackage"></DlgExtPackage>
                                </v-toolbar>
                                
                                <v-divider></v-divider>
                                <v-card-text  class="text-left">
                                        <v-row  v-for="(item, index) in selectedExtPackageList" :key="index">
                                            <v-col class="pt-0 pb-0" cols="10">
                                                <v-card-text> <b style="padding-right:20px">{{item.ext_package_name}}</b>
                                                ตั้งแต่ {{item.start_package_date_display}} ถึง {{item.end_package_date_display}}
                                                </v-card-text>
                                            </v-col>
                                            <v-spacer></v-spacer>
                                            <v-col  class="justify-right">
                                                <v-btn text @click="deleteItem(item)"><v-icon>delete</v-icon></v-btn>
                                            </v-col>
                                        </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    </v-form> 
                </div>
                <v-divider></v-divider>
                <v-card-actions class="text-right">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="saveDialog">บันทึก</v-btn>
                    <v-btn color="primary" @click="closeDialog"> ยกเลิก</v-btn>
                </v-card-actions>
            </v-card>
    </v-dialog>
</template>

<style scoped>
    .right-text {
        text-align: right;
    }
    .header-color {
        background-color: aliceblue;
    }
</style>
<script>

import axios from 'axios';
import config from '@/../config.js'
import Staff from '@/model/instance/Staff.js'
import moment from 'moment';
import DlgExtPackage from './DlgExtPackage'
import PeriodComponent from '@/components/Common/PeriodComponent'

export default {
    name: 'DlgStationPackage',
    components: {
        //DlgCustomer,
        DlgExtPackage,
        PeriodComponent
    },
    props: ["currCustomer"],
    watch: {
        "editedItem.package_id": function(val) {
            if (!val || this.packageList == undefined || this.packageList.length <= 0) return;
            this.selectedPackage = this.packageList.filter(o => o.package_id == val)[0];
            if (this.isEdit && !this.isFirstEditLoad) {
                this.selectedExtPackageList = new Array(0);
                this.selectedExtPackageQty = new Array(0);
            }
            this.isFirstEditLoad = false;
        },
        selectedPackage(val) {
            if (val.line_noti_per_month == 0) val.line_noti_per_month = "0";
            if (val.supervisor == 0) val.supervisor = "0";
            if (val.viewer == 0) val.viewer = "0";
        },
        dialog(val) {
            if (val) {
                this.loadMainPackage();
                this.loadExtPackage();
                this.loadCustomer();
            }
        }
    },
    data: () => ({
        rules: {
            required: value => !!value || 'กรุณากรอกข้อมูล.',
            requiredNumber: value => !!value && (value >= 0) || 'กรุณากรอกตัวเลขที่มีค่ามากกว่าหรือเท่ากับ 0',
        },
        dialog: false,
        editedItem: {
            period: '',
            start_package_date: ''
        },
        selectedPackage: {},
        selectedExtPackageList: [],
        selectedExtPackageQty:[],
        isEdit: false,
        isFirstEditLoad: true,
        customerList: [],
        packageList: [],
        extPackageList: [],
        periodList: [
            {itemValue: '1', itemText: '1 เดือน'},
            {itemValue: '2', itemText: '2 เดือน'},
            {itemValue: '3', itemText: '3 เดือน'},
            {itemValue: '4', itemText: '4 เดือน'},
            {itemValue: '5', itemText: '5 เดือน'},
            {itemValue: '6', itemText: '6 เดือน'},
            {itemValue: '7', itemText: '7 เดือน'},
            {itemValue: '8', itemText: '8 เดือน'},
            {itemValue: '9', itemText: '9 เดือน'},
            {itemValue: '10', itemText: '10 เดือน'},
            {itemValue: '11', itemText: '11 เดือน'},
            {itemValue: '12', itemText: '12 เดือน'},
        ]
    }),
    methods: {
        setPeriod(val) {
            this.editedItem.period = val;
        },
        setStartPackageDate(val) {
            this.editedItem.start_package_date = val;
        },
        setEndPackageDate(val) {
            this.editedItem.end_package_date = val;
        },
        onCloseDialog(success) {
            if (success) {
                this.loadCustomer();
            }
        },
        onCloseExtPackage(item) {
            if (!item || item == undefined || !item.ext_package_id) return;
            this.selectedExtPackageList.push({
                ext_package_id: item.ext_package_id,
                ext_package_name: item.ext_package_name,
                start_package_date: item.startPackageDate,
                start_package_date_display: moment(item.startPackageDate).format('DD-MM-yyyy'),
                end_package_date_display: moment(item.endPackageDate).format('DD-MM-yyyy'),
                end_package_date: item.endPackageDate
            });
        },
        deleteItem(item) {
            let idx = this.selectedExtPackageList.indexOf(item);
            this.selectedExtPackageList.splice(idx, 1);
        },
        isChecked(index) {
            return this.selectedExtPackageList.filter(e => e == (index + 1)).length > 0;
        },
        getBooleanText(val) {
            return val == true ? "มีให้" : "ไม่มีให้";
        },
        loadCustomer() {
            this.customerList = [];
            var que = this.$store.commit('addLoading')
            axios.get(
                config.api.url.manage.customer.list,
                { headers: Staff.getTokenHeader()}
            ).then(rs => {
                this.$store.commit('finishLoading',que)
                this.customerList = rs.data;
            }).catch(e => {
                this.$store.commit('finishLoading',que)
                console.log(e);
            });
        },
        loadMainPackage() {
            var que = this.$store.commit('addLoading')
            axios.get(
                config.api.url.manage.package.list_package,
                { headers: Staff.getTokenHeader()}
            ).then(rs => {
                this.$store.commit('finishLoading',que)
                this.packageList = rs.data;
                if (this.editedItem && this.editedItem.package_id) {
                 //   this.selectedPackage = this.packageList.filter(o => o.package_id == this.editedItem.package_id)[0];
                } else {
                    
                    this.editedItem = { 
                        package_id: this.packageList[0].package_id,
                        period: '6',
                        start_package_date: new Date().toISOString().substr(0, 10),
                    };
                    this.$refs.period.setDefaultStartDate(this.editedItem.start_package_date);
                }
            })
            .catch(error => {
                this.$store.commit('finishLoading',que)
                this.$router.push({name:'Error',params:error}) 
            });
        },
        loadExtPackage() {
            var que = this.$store.commit('addLoading')
            axios.get(
                config.api.url.manage.ext_package.list_ext_package_by_type + '1',
                { headers: Staff.getTokenHeader()}
            ).then(rs => {
                this.$store.commit('finishLoading',que)
                this.extPackageList = rs.data;
                if (this.selectedExtPackageList && this.selectedExtPackageList.length > 0) {
                    this.selectedExtPackageList.forEach(e => {
                        let filter = this.extPackageList.filter(o => o.ext_package_id == e.ext_package_id);
                        if (filter.length > 0) {
                            e.ext_package_name = filter[0].ext_package_name;
                            e.start_package_date_display = e.start_package_date;
                            e.end_package_date_display = e.end_package_date;
                        }
                    });
                }
                /*
                 this.selectedExtPackageList = new Array(this.extPackageList.length);
                 this.selectedExtPackageQty = new Array(this.extPackageList.length);

                 if (this.editedItem && this.editedItem.selectedExtPackageList) {
                    this.extPackageList.forEach((e, i) => {
                        let filter = this.editedItem.selectedExtPackageList.filter(o => o.ext_package_id == e.ext_package_id);
                        if (filter.length > 0) {
                            this.selectedExtPackageList[i] = (e.ext_package_id);
                            this.selectedExtPackageQty[i] = filter[0].qty;

                        }
                    });
                }
                */
            })
            .catch(error => {
                this.$store.commit('finishLoading',que)
                this.$router.push({name:'Error',params:error}) 
            });
        },
        saveDialog() {
            if (!this.$refs.formData.validate()) {
                return;
            }
            this.fillData(this.selectedPackage, this.editedItem);
            this.editedItem.selectedExtPackageList = [];
            this.selectedExtPackageList.forEach((e) => {
                if (!e) return;
                var startDate = e.start_package_date
                if(startDate!=undefined && startDate!=null && startDate.length>0){
                    if(startDate.split('-')[0].length<4){
                        startDate = startDate.split('-')
                        startDate = startDate[2] + '-' + startDate[1] + '-' + startDate[0] 
                    }
                }
                var endDate = e.end_package_date
                if(endDate!=undefined && endDate!=null && endDate.length>0){
                    if(endDate.split('-')[0].length<4){
                        endDate = endDate.split('-')
                        endDate = endDate[2] + '-' + endDate[1] + '-' + endDate[0] 
                    }
                }
                this.editedItem.selectedExtPackageList.push ({
                    ext_package_id: e.ext_package_id,
                    start_package_date: startDate,
                    end_package_date: endDate,
                    qty: 1
                });
            });
            let url = this.isEdit ? config.api.url.manage.customerpackage.update_customer_package + this.editedItem.customer_package_id : config.api.url.manage.customerpackage.insert_customer_package;
            var que = this.$store.commit('addLoading')
            axios.post(url, this.editedItem, { headers: Staff.getTokenHeader()}).then(() => {
                this.$store.commit('finishLoading',que)
                 this.closeDialog(true);
                 
            })
            .catch(error => {
                this.$store.commit('finishLoading',que)
                this.$router.push({name:'Error',params:error});
            });
           
        },
        fillData(srcItem, targetItem) {
            targetItem.line_noti_per_month = srcItem.line_noti_per_month;
            targetItem.supervisor = srcItem.supervisor;
            targetItem.viewer = srcItem.viewer;
            targetItem.line_noti_member_fee = srcItem.line_noti_member_fee;
            targetItem.member_fee = srcItem.member_fee;
            targetItem.platform_service_charge = srcItem.platform_service_charge;
        },
        closeDialog(isSuccess) {
            this.editedItem = {};
            this.editedItem.selectedExtPackageList = [];
            this.selectedExtPackageList = [];
            this.extPackageList = [];
            this.dialog = false;
            this.isEdit = false;
            this.$emit("onCloseDialog", isSuccess);
        },
        show(item) {
            
            let period = item.period; // pass by value
            this.isFirstEditLoad = true;
            this.dialog = true;
            this.editedItem = item;
            this.fillData(this.editedItem, this.selectedPackage);
            this.selectedExtPackageList = item.selectedExtPackageList;
            this.isEdit = true;
            this.editedItem.start_package_date = moment(item.start_package_date, 'DD-MM-yyyy').format('yyyy-MM-DD');
            this.editedItem.end_package_date = moment(item.end_package_date, 'DD-MM-yyyy').format('yyyy-MM-DD');
            
            
            this.$nextTick(() => {
                this.$refs.period.setDefaultPeriod(period);
                this.$refs.period.setDefaultStartDate(this.editedItem.start_package_date);
                //this.$refs.endDate.setDate(this.editedItem.end_package_date);
            })
            
        }
    }
}
</script>